import Chip from '@mui/material/Chip';

export default function LabelAsaas({ item }) {
    const arrStatus = {
        'PENDING': { label: 'PENDENTE', color: "primary"},
        'OVERDUE': { label: 'EM ATRASO', color: "error"},  
        'RECEIVED': { label: 'RECEBIDO', color: "success"},
        'CANCELED': { label: 'CANCELADA', color: "warning" }
    };
    const status = arrStatus[item] ? arrStatus[item] : { label: "OUTROS", color: "secondary" };

    return(
        <Chip label={status.label || ""} color={status.color || 'default'} />
    );
}